var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.459 7.228a8.088 8.088 0 0 1-3.661-2.569A11.06 11.06 0 0 0 20 .5a9.047 9.047 0 0 0-9.583 7.667 6.191 6.191 0 0 1 6.708-2.856 8.28 8.28 0 0 1 3.661 2.587A11.06 11.06 0 0 0 29.583 12a9.046 9.046 0 0 0 9.584-7.667 6.133 6.133 0 0 1-6.709 2.895ZM7.541 16.773a8.089 8.089 0 0 1 3.66 2.568A11.06 11.06 0 0 0 20 23.5a9.046 9.046 0 0 0 9.584-7.667 6.19 6.19 0 0 1-6.709 2.856 8.28 8.28 0 0 1-3.66-2.587A11.116 11.116 0 0 0 10.416 12a9.047 9.047 0 0 0-9.584 7.667 6.133 6.133 0 0 1 6.709-2.895Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.2969d0e3f9b58c8f972142ed73212c6e.svg";
export { ForwardRef as ReactComponent };